import { SsoCookieInit } from "@heytap/sso-client";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import CookUI from "@heytap/cook-ui";
import "@heytap/cook-ui/lib/theme-chalk/index.css";
import VueCompositionApi from "@vue/composition-api";
import Uploader from "./components/uploader/index";
import badjs from "./badjs";
import SliceUploder from "@oppo/slice-uploader";
import "@/components/svgIcon/index.ts";
if (badjs) {
  badjs.installVueErrorHandler(Vue);
}
export const clearCookie = SsoCookieInit({
  domainLevel: 3
});

Vue.use(VueCompositionApi);
// Vue.use(ElementUI);
Vue.use(CookUI, { supportElementUI: true });
Vue.use(Uploader);
Vue.use(SliceUploder);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
